export default __webpack_public_path__ + "static/indicina-4711be3ec4b0e1435d6e626a0572d155.png";